import { Box, Button, Checkbox, CircularProgress, FormControlLabel, Link } from '@mui/material'
import ImageBanner from 'components/image-banner'
import LogoTheme from 'components/logo-theme'
import SecuritySVG from 'components/svg/security'
import WrapperPermission from 'components/wrapper-permission'
import { useStyles } from './styles'
import useComponent from './use-component'

const Terms = () => {
  const classes = useStyles()

  const {
    form: {
      register,
      handleSubmit,
      formState: { isSubmitting },
    },
    theme,
    disabled,
    onSubmit,
    setDisabled,
    handleChange,
  } = useComponent()

  return (
    <Box className={classes.container}>
      <Box className={classes.mainWrapper}>
        <WrapperPermission>
          <Box className={classes.connectBox}>
            <Box
              display='flex'
              alignItems='center'
              sx={{ mb: '1rem' }}
            >
              <LogoTheme />
            </Box>

            <p className={classes.formSubTitle}>
              Antes de prosseguir, por favor, leia atentamente os seguintes termos e políticas
            </p>

            <Box
              component='form'
              onSubmit={handleSubmit(onSubmit)}
              noValidate
              data-testid='form'
              className={classes.formBox}
              marginTop='16px'
            >
              <p>
                Ao marcar a caixa abaixo, você declara ter lido, compreendido e concordado com os Termos de Uso e a
                Política de Privacidade da Conducco. Estes documentos regulam o uso dos nossos serviços e a proteção dos
                seus dados pessoais. Se você não concorda com estes termos, por favor, abstenha-se de utilizar nossos
                serviços.
              </p>
              <FormControlLabel
                control={
                  <Checkbox
                    onChange={(e) => setDisabled(!e.target.checked)}
                    disabled={isSubmitting}
                    sx={{
                      mt: '-20px',
                      borderColor: '#0f0f1e !important',
                      opacity: 0.6,
                    }}
                  />
                }
                label={
                  <div className={classes.acceptArea}>
                    <span>
                      Li e concordo com os{' '}
                      <Link
                        download
                        href='/documents/Termose_Condicoes_Conducco-10_01_2024.pdf'
                      >
                        Termos de Uso{' '}
                      </Link>
                      e a{' '}
                      <Link
                        target='_blank'
                        href='/documents/Politica_Privacidade'
                      >
                        Política de Privacidade{' '}
                      </Link>
                      da Conducco
                    </span>
                  </div>
                }
                {...register('acceptance', {
                  onChange: (e) => handleChange(e),
                })}
              />

              <Box
                display='flex'
                flexDirection='column'
                gap='1rem'
                alignItems='center'
                width='100%'
              >
                <Button
                  variant='contained'
                  type='submit'
                  size='large'
                  fullWidth
                  disabled={isSubmitting || disabled}
                  sx={{
                    mt: 2,
                    mb: 1,
                    '&.Mui-disabled': {
                      backgroundColor: '#8C9097 !important',
                      color: '#FFF !important',
                    },
                  }}
                >
                  {isSubmitting ? (
                    <CircularProgress
                      color='inherit'
                      size={26}
                    />
                  ) : (
                    'ACEITAR'
                  )}
                </Button>
              </Box>
            </Box>
          </Box>
        </WrapperPermission>

        <ImageBanner
          title='A Conducco garante a privacidade e a segurança dos seus dados, seguindo rigorosos padrões de proteção.'
          banner={<SecuritySVG />}
        />
      </Box>
    </Box>
  )
}

export default Terms
